import SettingProperties from "../../../../contents/docs/integrate/send-events/_snippets/setting-properties-text.mdx";
import NamingTip from "../../../../contents/docs/integrate/send-events/_snippets/naming-tip.mdx";
import * as React from 'react';
export default {
  SettingProperties,
  NamingTip,
  React
};